import type { QuoteTemplateDefinition } from './QuoteTypes'

/**
 * QuoteTemplates — reusable quote structures (no free-text products).
 * Product blocks reference template productIds (resolved via comparison later).
 */
export const QUOTE_TEMPLATES: QuoteTemplateDefinition[] = [
  {
    id: 'tpl:desktop-escritorio',
    name: 'Desktop Escritório',
    category: 'Desktop',
    blocks: [
      { type: 'title', description: 'Desktop Corporativo', productId: 'sys:title:desktop', origin: 'template' },
      { type: 'product', description: 'CPU AMD Ryzen 5 8600G', productId: 'tpl:cpu-8600g', origin: 'template', purchasePrice: 1100, salePrice: 1390, fingerprint: 'AMD-5-8600G-CPU' },
      { type: 'product', description: 'Placa Mãe B650', productId: 'tpl:mb-b650', origin: 'template', purchasePrice: 780, salePrice: 990, fingerprint: 'B650-PLACA-MAE' },
      { type: 'product', description: 'RAM 16GB DDR5', productId: 'tpl:ram-16', origin: 'template', purchasePrice: 320, salePrice: 420, fingerprint: 'RAM-16GB' },
      { type: 'product', description: 'SSD Kingston NV3 1TB', productId: 'tpl:ssd-nv3', origin: 'template', purchasePrice: 300, salePrice: 389, fingerprint: 'KINGSTON-NV3-SNV3S1000G' },
      { type: 'product', description: 'Fonte 650W', productId: 'tpl:psu-650', origin: 'template', purchasePrice: 280, salePrice: 360 },
      { type: 'product', description: 'Gabinete Cooler Master', productId: 'tpl:case-cm', origin: 'template', purchasePrice: 220, salePrice: 290 },
      { type: 'service', description: 'Windows 11 Pro', productId: 'svc:configuracao', origin: 'service_catalog', salePrice: 899, purchasePrice: 0 },
      { type: 'service', description: 'Instalação', productId: 'svc:instalacao', origin: 'service_catalog', salePrice: 150, purchasePrice: 0 },
      { type: 'service', description: 'Configuração', productId: 'svc:configuracao', origin: 'service_catalog', salePrice: 120, purchasePrice: 0 },
    ],
  },
  {
    id: 'tpl:desktop-premium',
    name: 'Desktop Premium',
    category: 'Desktop',
    blocks: [
      { type: 'title', description: 'Desktop Premium', productId: 'sys:title:premium', origin: 'template' },
      { type: 'product', description: 'CPU AMD Ryzen 7 9700X', productId: 'tpl:cpu-9700x', origin: 'template', purchasePrice: 1800, salePrice: 2299 },
      { type: 'product', description: 'GPU GeForce RTX 5060', productId: 'tpl:gpu-5060', origin: 'template', purchasePrice: 2100, salePrice: 2599 },
      { type: 'product', description: 'SSD Kingston NV3 1TB', productId: 'tpl:ssd-nv3', origin: 'template', purchasePrice: 300, salePrice: 389 },
      { type: 'service', description: 'Montagem', productId: 'svc:montagem', origin: 'service_catalog', salePrice: 220, purchasePrice: 0 },
    ],
  },
  {
    id: 'tpl:notebook-empresarial',
    name: 'Notebook Empresarial',
    category: 'Notebook',
    blocks: [
      { type: 'title', description: 'Notebook Empresarial', productId: 'sys:title:nb', origin: 'template' },
      { type: 'product', description: 'Notebook Dell Latitude 5450', productId: 'tpl:nb-lat', origin: 'template', purchasePrice: 4200, salePrice: 5190 },
      { type: 'service', description: 'Configuração', productId: 'svc:configuracao', origin: 'service_catalog', salePrice: 120, purchasePrice: 0 },
      { type: 'warranty', description: 'Garantia estendida 12 meses', productId: 'sys:warranty:12', origin: 'system' },
    ],
  },
  {
    id: 'tpl:servidor',
    name: 'Servidor',
    category: 'Servidor',
    blocks: [
      { type: 'title', description: 'Servidor', productId: 'sys:title:srv', origin: 'template' },
      { type: 'product', description: 'Servidor Dell PowerEdge R760', productId: 'tpl:srv-r760', origin: 'template', purchasePrice: 24000, salePrice: 29800 },
      { type: 'service', description: 'Configuração', productId: 'svc:configuracao', origin: 'service_catalog', salePrice: 450, purchasePrice: 0 },
      { type: 'service', description: 'Visita Técnica', productId: 'svc:visita', origin: 'service_catalog', salePrice: 180, purchasePrice: 0 },
    ],
  },
  {
    id: 'tpl:rede',
    name: 'Rede',
    category: 'Rede',
    blocks: [
      { type: 'title', description: 'Infraestrutura de Rede', productId: 'sys:title:net', origin: 'template' },
      { type: 'product', description: 'Switch TP-Link 24 portas', productId: 'tpl:sw-24', origin: 'template', purchasePrice: 720, salePrice: 980 },
      { type: 'product', description: 'Mikrotik hAP ax3', productId: 'tpl:mt-hap', origin: 'template', purchasePrice: 680, salePrice: 890 },
      { type: 'service', description: 'Configuração', productId: 'svc:configuracao', origin: 'service_catalog', salePrice: 250, purchasePrice: 0 },
    ],
  },
  {
    id: 'tpl:impressora',
    name: 'Impressora',
    category: 'Impressora',
    blocks: [
      { type: 'product', description: 'Impressora HP LaserJet Pro', productId: 'tpl:prn-hp', origin: 'template', purchasePrice: 1450, salePrice: 1899 },
      { type: 'service', description: 'Instalação', productId: 'svc:instalacao', origin: 'service_catalog', salePrice: 150, purchasePrice: 0 },
    ],
  },
  {
    id: 'tpl:monitor',
    name: 'Monitor',
    category: 'Monitor',
    blocks: [
      { type: 'product', description: 'Monitor Dell 27 Polegadas', productId: 'tpl:mon-27', origin: 'template', purchasePrice: 980, salePrice: 1299 },
    ],
  },
  {
    id: 'tpl:kit-escola',
    name: 'Kit Escola',
    category: 'Desktop',
    blocks: [
      { type: 'title', description: 'Kit Escola', productId: 'sys:title:escola', origin: 'template' },
      { type: 'product', description: 'Desktop Escritório', productId: 'tpl:desk-school', origin: 'template', purchasePrice: 2200, salePrice: 2890 },
      { type: 'product', description: 'Monitor Dell 27 Polegadas', productId: 'tpl:mon-27', origin: 'template', purchasePrice: 980, salePrice: 1299 },
      { type: 'service', description: 'Instalação', productId: 'svc:instalacao', origin: 'service_catalog', salePrice: 150, purchasePrice: 0 },
    ],
  },
  {
    id: 'tpl:kit-empresa',
    name: 'Kit Empresa',
    category: 'Desktop',
    blocks: [
      { type: 'title', description: 'Kit Empresa', productId: 'sys:title:empresa', origin: 'template' },
      { type: 'product', description: 'Notebook Dell Latitude 5450', productId: 'tpl:nb-lat', origin: 'template', purchasePrice: 4200, salePrice: 5190 },
      { type: 'product', description: 'Monitor Dell 27 Polegadas', productId: 'tpl:mon-27', origin: 'template', purchasePrice: 980, salePrice: 1299 },
      { type: 'service', description: 'Configuração', productId: 'svc:configuracao', origin: 'service_catalog', salePrice: 120, purchasePrice: 0 },
      { type: 'service', description: 'Treinamento', productId: 'svc:treinamento', origin: 'service_catalog', salePrice: 400, purchasePrice: 0 },
    ],
  },
]

export class QuoteTemplates {
  list() {
    return QUOTE_TEMPLATES
  }

  get(id: string) {
    return QUOTE_TEMPLATES.find((t) => t.id === id) ?? null
  }

  byCategory(category: string) {
    return QUOTE_TEMPLATES.filter((t) => t.category === category)
  }
}

export const quoteTemplates = new QuoteTemplates()
